import React from "react";
import { ViewerItemsColorChangedModel } from "./models/viewer-items-color-changed-model";
import FormattedObject from "@/models/interfaces/viewer/formatted-object.ts";
import SpaceTypo from "@/models/enums/space-typo";
import ThermicTypo from "@/models/enums/thermic-typo";

export interface ViewerItemsColorContextProps {
    subscribeColorChanged: (callback: (event: ViewerItemsColorChangedModel) => void) => void;
    changeColor: (items: FormattedObject[], color: string, shellTypo: SpaceTypo | undefined, thermalTypo: ThermicTypo | undefined) => void;
}

export const ViewerItemsColorContext = React.createContext<ViewerItemsColorContextProps | undefined>(undefined);